import { useTranslation as e } from "../../i18n.mjs";
import { keepEditorFocusOnMouseDown as t } from "./keep-editor-focus.mjs";
import { ToolbarDrawer as n } from "./toolbar-drawer.mjs";
import { createContext as r, useCallback as i, useContext as a, useMemo as o, useRef as s, useState as c } from "react";
import { Button as l, Popover as u, breakpointQueries as d, useMediaQuery as f } from "@systemeio/components";
import { jsx as p, jsxs as m } from "react/jsx-runtime";
import { Toolbar as h } from "@base-ui/react/toolbar";
import { DotsHorizontalIcon as g } from "@systemeio/icons";
//#region src/components/content-controls/toolbar-sheet.tsx
var _ = r({
	close: () => {},
	surface: "popup"
}), v = () => a(_);
function y({ children: r }) {
	let { t: a } = e(), [v, y] = c(!1), b = s(null), x = f(d.isMobile, { initializeWithValue: !1 }), S = a("global.more_options"), C = i(() => y(!1), []), w = o(() => ({
		close: C,
		surface: x ? "drawer" : "popup"
	}), [C, x]), T = /* @__PURE__ */ p(l, {
		"aria-label": S,
		className: "data-popup-open:bg-button-secondary-pressed",
		onMouseDown: t(),
		size: "icon-sm",
		variant: "secondary",
		children: /* @__PURE__ */ p(g, {})
	}), E = /* @__PURE__ */ p(_.Provider, {
		value: w,
		children: /* @__PURE__ */ p(h.Root, {
			"aria-label": S,
			className: "flex flex-col items-stretch",
			orientation: "vertical",
			ref: b,
			children: r
		})
	});
	return x ? /* @__PURE__ */ p(n, {
		contentClassName: "gap-0 px-0 py-4",
		onOpenChange: y,
		open: v,
		title: S,
		trigger: T,
		children: E
	}) : /* @__PURE__ */ m(u.Root, {
		onOpenChange: y,
		open: v,
		children: [/* @__PURE__ */ p(u.Trigger, { render: T }), /* @__PURE__ */ p(u.Portal, { children: /* @__PURE__ */ p(u.Positioner, {
			align: "end",
			side: "bottom",
			children: /* @__PURE__ */ p(u.Popup, {
				className: "max-h-[60vh] max-w-(--available-width) min-w-56 overflow-y-auto py-1",
				initialFocus: (e) => e === "keyboard" ? b.current?.querySelector("[tabindex=\"0\"]") ?? !0 : !1,
				children: E
			})
		}) })]
	});
}
//#endregion
export { y as ToolbarOverflowSheet, v as useToolbarSheet };
